import { computed, Injectable, signal } from '@angular/core';
import { PrivacyConsentStorageService } from './privacy-consent-storage.service';

@Injectable({ providedIn: 'root' })
export class PrivacyConsentService {
    constructor(private privacyConsentStorageService: PrivacyConsentStorageService) {

    }

    private readonly _accepted = signal<boolean>(this.privacyConsentStorageService.isAccepted());
    readonly accepted = computed(() => this._accepted());

    accept(): void {
        this._accepted.set(true);
        this.privacyConsentStorageService.saveAccepted();
    }

    reset(): void {
        this._accepted.set(false);
        this.privacyConsentStorageService.clear();
    }
}